<template>
	<div>
		<input
			ref="inputFile"
			type="file"
			:accept="accept"
			:multiple="multiple"
			hidden
			@input="fileSelected"
		>
		<slot>
			<v-btn small color="primary" @click="openFileDialog">{{ label }}</v-btn>
		</slot>
	</div>
</template>

<script>
	export default {
		props: {
			label: {
				default: 'Adicionar'
			},

			accept: {
				default: 'image/png, image/jpeg, application/pdf'
			},

			multiple: {
				default: false
			},

			size: {
				default: Infinity
			}
		},

		methods: {
			openFileDialog() {
				this.$refs.inputFile.click();
			},

			fileSelected(e) {
				let file = e.target.files[0];
				let accepted = this.accept.split(',').map(v => v.trim().toLowerCase());

				if (!accepted.includes(file.type)) {
					this.$emit('file-error', 'O tipo de arquivo não é permitido!');
				} else if (file.size > this.size) {
					this.$emit('file-error', 'O tamanho do arquivo excede o permitido!');
				} else {
					this.$emit('file-selected', e);
				}

				this.$refs.inputFile.value = '';
			}
		}
	};
</script>